// This stuff was all in the footer in script tags

document.querySelector("#dropdownMenuButton").addEventListener("click", function (event) {
	var button = document.querySelector("#dropdownMenuButton");
	var label = button.querySelector(".label");

	if (button.getAttribute("aria-expanded") === "false") {
		button.setAttribute("aria-expanded", "true");
		label.textContent = button.getAttribute("data-label-open");
	} else {
		button.setAttribute("aria-expanded", "false");
		label.textContent = button.getAttribute("data-label-closed");
	}
});

var elem = document.getElementsByClassName("nav-button");
for (var i = 0; i < elem.length; i++) {
	elem[i].addEventListener(
		"click",
		function () {
			event.target.classList.toggle("expand");
			event.target.nextElementSibling.classList.toggle("second-level");
		},
		true,
	);
}

jQuery(".navbar-nav").on("click", function (event) {
	// The event won't be propagated up to the document NODE and
	// therefore delegated events won't be fired
	event.stopPropagation();
});
jQuery(".mobile-menu-footer").on("click", function (event) {
	// The event won't be propagated up to the document NODE and
	// therefore delegated events won't be fired
	event.stopPropagation();
});

if ("IntersectionObserver" in window || !!window.IntersectionObserver) {
	// Set up observer
	var scrollToTopObserver = new IntersectionObserver(
		function (entries, observer) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					document.querySelector(".scrollToTopBtn").classList.add("is-hidden");
				} else {
					document.querySelector(".scrollToTopBtn").classList.remove("is-hidden");
				}
			});
		},
		{ threshold: 1 },
	);

	// Activate observer
	var elements = document.querySelectorAll(".site-header");
	elements.forEach(function (element) {
		scrollToTopObserver.observe(element);
	});
}
